<div class="col-12 " style="margin-top: 10%;
margin-bottom: 10%;" align="center">



<img src="./assets/img/succes.png" alt="" width="100">


<h4>{{ dataSource}}</h4>


</div>
<style>
@media only screen and (min-width: 600px) {
  .container {
    width: 350px;
    max-width: 100%;
  }

  ::ng-deep .mat-bottom-sheet-container-large {
    min-width: 400px !important;
    max-width: calc(100vw - 256px);

  }
}
  </style>